/* istanbul ignore file */
import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import featureFlags from './featureFlags'
import user from './user'
import initialLeadData from './initialLeadData'
import initialLeadValidations from './initialLeadValidations'
import analyticsConfig from './analyticsConfig'

export default combineReducers({
  featureFlags,
  form: formReducer,
  user,
  initialLeadData,
  initialLeadValidations,
  analyticsConfig,
})
